import { render } from "./toolbar.vue?vue&type=template&id=4f0fa272"
import script from "./toolbar.vue?vue&type=script&lang=js"
export * from "./toolbar.vue?vue&type=script&lang=js"

import "./toolbar.vue?vue&type=style&index=0&id=4f0fa272&lang=postcss"
script.render = render

export default script